import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';

import Asterisk from '@atoms/Asterisk';
import RadioWithoutForm from '@atoms/RadioWithoutForm';
import { BodyMedium, BodySmall, LinkBase } from '@styled';

import useIsCaslConsentRequired from '@hooks/useIsCaslConsentRequired';

const CaslConsentForm = ({ formValue, mainAddressCountry, name, setFieldValue, setIsRequired }) => {
    const [, meta] = useField(name);
    const hasError = meta.touched && meta.error;

    const caslConsentRequired = useIsCaslConsentRequired(mainAddressCountry);

    useEffect(() => {
        setIsRequired(caslConsentRequired);
    }, [caslConsentRequired, setIsRequired]);

    if (!caslConsentRequired) return null;

    return (
        <div>
            <BodyMedium className={!hasError ? 'mb-1.5rem' : null}>
                CASL Express Consent <Asterisk />
            </BodyMedium>
            {hasError ? <BodySmall className="mt-0.25rem mb-0.25rem text-error">{meta.error}</BodySmall> : null}
            <RadioWithoutForm
                checked={formValue === true}
                label="Yes"
                name={name}
                onChange={() => setFieldValue(name, true)}
                value="yes"
            />
            <RadioWithoutForm
                checked={formValue === false}
                label="No thanks"
                name={name}
                onChange={() => setFieldValue(name, false)}
                value="no"
            />
            <BodySmall className="mt-1.5rem">
                To change contact permissions or reset your email preferences, please contact us at{' '}
                <a className="accent" href="mailto:membership@icsc.com">
                    membership@icsc.com
                </a>
                . See our{' '}
                <LinkBase href="/privacy-policy" target="_blank" rel="noreferrer">
                    privacy policy
                </LinkBase>{' '}
                for more information on our practices.
            </BodySmall>
        </div>
    );
};

CaslConsentForm.propTypes = {
    formValue: PropTypes.bool,
    mainAddressCountry: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    setIsRequired: PropTypes.func.isRequired,
};

export default CaslConsentForm;
